// extracted by mini-css-extract-plugin
export default {"Div":"Button_Div__cV+ez","Button":"Button_Button__HJEPX","progress":"Button_progress__NKMB7","progress__status":"Button_progress__status__V+N29"};